import { createI18n } from 'vue-i18n'; // Use named import for createI18n
import messages from '../../src/i18n'; // Adjust the path to your messages

export function useI18n() {
  const i18n = createI18n({
    legacy: false, // Disable legacy API mode
    globalInjection: true, // Enable global injection
    locale: navigator.language,
    fallbackLocale: 'en-us',
    messages,
  });

  return { i18n };
}